import React from "react";
import styles from "./RiskAssessmentList.module.scss";
import { dateOfBirthDate } from "../../../../utils";
import { Spinner } from "../../../secondary/Loader/Spinner";
import { getRiskColor, getRiskLabel, hexToRgba } from "./utils/riskAssessment.utils";

const RiskAssessmentList = ({ onSelect, selectedId, assessments = [], loading }) => {
  const handleCardKeyDown = (e, item) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onSelect(item);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.panelHeader}>
        <span className={styles.panelLabel}>Assessments</span>
        {assessments?.length > 0 && <span className={styles.panelCount}>{assessments.length}</span>}
      </div>

      {loading && (
        <div className={styles.loadingWrap}>
          <Spinner />
        </div>
      )}

      {!loading && assessments && assessments.length > 0 && (
        <div className={styles.list}>
          {assessments.map((item) => {
            const riskColor = getRiskColor(item.score);
            const isSelected = selectedId === item.id;

            return (
              <div
                key={item.id}
                className={`${styles.card} ${isSelected ? styles.cardSelected : ""}`}
                style={{ "--risk-color": riskColor }}
                role="button"
                tabIndex={0}
                aria-pressed={isSelected}
                onClick={() => onSelect(item)}
                onKeyDown={(e) => handleCardKeyDown(e, item)}
              >
                <div className={styles.cardTop}>
                  <p className={styles.cardTitle}>{item.name}</p>
                    <span className={styles.chevron} aria-hidden="true">
                      {isSelected ? (
                        <span className={styles.selectedCard}>
                          <i className="fa fa-check-circle" aria-hidden="true"></i>
                        </span>
                      ) : (
                        <span>&#8250;</span>
                      )}
                    </span>
                </div>

                <div className={styles.scoreRow}>
                  <span className={styles.score} style={{ color: riskColor }}>
                    {item.score}
                  </span>
                  <span className={styles.badge} style={{ backgroundColor: hexToRgba(riskColor, 0.16), color: riskColor }}>
                    {item.scaleName || getRiskLabel(item.score)}
                  </span>
                </div>

                <div className={styles.dateRow}>
                  <span className={styles.dateLabel}>Last updated</span>
                  <span className={styles.dateValue}>{dateOfBirthDate(item.updatedDate)}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {!loading && assessments?.length === 0 && (
        <div className={styles.emptyState}>
          <p className={styles.emptyBody}>No assessments yet</p>
        </div>
      )}
    </div>
  );
};

export default RiskAssessmentList;
